const defaultTextValues = {
  title: {
    en: 'Title example'
  },
  subtitle: {
    en: 'Subtitle example'
  },
  sectionVideoTitle: {
    en: 'Ux pro tips!'
  },
  videoParagraph: {
    en: 'Your text goes here. Insert your content, thoughts, or information in this space.'
  },
  streamParagraph: {
    en: 'Your text goes here. Insert your content, thoughts, or information in this space.'
  },
  paragraph: {
    en: 'Your text goes here. Insert your content, thoughts, or information in this space.'
  },
  buttonPrimary: {
    en: 'Button'
  },
  buttonHeroPrimary: {
    en: 'Button'
  },
  buttonHeroPrimaryTop: {
    en: 'Get tickets'
  },
  buttonHeroSecondary: {
    en: 'Button'
  },
  buttonSecondary: {
    en: 'Button'
  },
  buttonHeroSecondaryTop: {
    en: 'Sign in'
  },
  description: {
    en: 'Your text goes here. Insert your content, thoughts, or information in this space.'
  },
  ticketBuy: {
    en: 'Register'
  },
  signInTitle: {
    en: 'Sign In'
  },
  eventButton: {
    en: 'Visit event website'
  },
};

export default defaultTextValues;
